import Vue from 'vue';
import vClickOutside from 'v-click-outside';
import Loading from 'vue-loading-overlay';
import VueDebounce from 'vue-debounce';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueSignature from 'vue-signature-pad';
import VCalendar from 'v-calendar';
import Notifications from 'vue-notification';
import DateFilter from './utils/date.filter';
import CalendarFilter from './utils/calendarDate.filter';
import App from './App.vue';
import router from './router';
import store from './store';
import { ApiService } from './services/api.service';
import { i18n, loadLanguageAsync } from './i18n-setup';

Vue.config.productionTip = false;

Vue.filter('date', DateFilter);
Vue.filter('calendarDate', CalendarFilter);

Vue.use(vClickOutside);
Vue.use(Loading);
Vue.use(VueSignature);
Vue.use(VCalendar);
Vue.use(VueDebounce);
Vue.use(Notifications, {
  componentName: 'VueFlyout',
});

ApiService.on(401, () => store.dispatch('logout'));
// If there exists a set language in local storage, set the language to be that lang by default.
// If one does not exist, check the browser for the users browser language.
router.beforeEach((to, from, next) => {
  if (!store.state.languages.language) {
    let initLanguage;
    if (localStorage.getItem('stellantis-language')) {
      initLanguage = localStorage.getItem('stellantis-language');
    } else {
      initLanguage = window.navigator.language;
    }
    if (!initLanguage || initLanguage === 'en-US' || initLanguage === 'fr-CA') {
      initLanguage = 'en';
    }
    store.state.languages.selectedLanguage = store.state.languages.languages.find(
      (object) => object.code === initLanguage,
    );
    ApiService.setLang(initLanguage);
    loadLanguageAsync(initLanguage);
  }
  next();
});

new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount('#app');
